export const LINK_FIXED_ASSETS_FLAG = 'PARTNER__CAN_LINK_FIXED_ASSETS';
